// extracted by mini-css-extract-plugin
export var columnList = "_bz-0";